import '@content/foundations/src/index'
import asWebComponent from '../../asWebComponent'
import FeaturedProducts from './FeaturedProducts'

export default asWebComponent(FeaturedProducts, 'nb-featured-products', [
    'data'
])
